import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { AlertModule } from '@vsolv/vectors-ui/alert';
import { ConnectivityInterceptor } from './interceptors';
import { ConnectivityService, ConnectivityToastService } from './services';

@NgModule({ imports: [AlertModule] })
export class ConnectivityModule {
  static forRoot(): ModuleWithProviders<ConnectivityModule> {
    return {
      ngModule: ConnectivityModule,
      providers: [
        ConnectivityService,
        ConnectivityToastService,
        { provide: HTTP_INTERCEPTORS, useClass: ConnectivityInterceptor, multi: true },
        {
          provide: APP_INITIALIZER,
          useFactory: (toastSvc: ConnectivityToastService) => () => toastSvc.start(),
          deps: [ConnectivityToastService],
          multi: true,
        },
      ],
    };
  }
}
